import React, { Component } from "react";
import { isEmpty, map, orderBy} from "lodash";
import BasicDetail from "./BasicDetail";
import moment from "moment-timezone";
import { DatePicker, message, Modal, Popconfirm, Select } from "antd";
import * as yup from "yup";
import plus_icon_green from "../../../../Assets/images/add-circle-outline-green.svg";
import AllState from "../../../../Assets/data/stateList.json";
// import chevronDown from '../../../../Assets/images/chevron-down.png';
import SideBar from "./SideBar";
import visa from "../../../../Assets/images/visa_dark.svg";
import american from "../../../../Assets/images/american_express_dark.svg";
import { DeleteOutlined } from "@ant-design/icons";
import EmptyData from "../../../Common/Component/EmptyData";
import {errorHandle} from "../../../Common/errorHandle";
// import TechnicianOutsideAlerter from "../../../Common/technicianOutsideAlerter";
import Loader from "../../../Common/Component/Loader";
import Axios from 'axios';
const {Option} = Select;

// mapping contact method
const contact_methods = [
  {key: 'By Text', value: 'text'},
  {key: 'Call Home Phone', value: 'home_phone'},
  {key: 'Call Mobile', value: 'mobile'},
  {key: 'By Email', value: 'email'},
]
const invoice_preferences = [
  {key: 'Print Invoice', value: 'is_print_and_mail_invoices'},
  {key: 'Email Invoice', value: 'is_email_invoice'},
]
const preferred_service_days = [
  {key: 'Any Day', value: 'any'},
  {key: 'Sunday', value: 'sunday'},
  {key: 'Monday', value: 'monday'},
  {key: 'Tuesday', value: 'Tuesday'},
  {key: 'Wednesday', value: 'wednesday'},
  {key: 'Thursday', value: 'thursday'},
  {key: 'Friday', value: 'friday'},
  {key: 'Saturday', value: 'saturday'},
]
const payment_methods = [
  {key: 'Cash or Check', value: 'cash_or_check'},
  {key: 'Credit Card', value: 'credit_card'},
]

class BillingInfo extends Component {
  fattJs = null;

  constructor(props) {
    super(props);
    this.state = {
      franchises: [],
      preferred_start_date: '',
      contactMethods: [],
      display_preferred_start_date: '',
      charge_invoice_card: true,
      is_print_and_mail_invoices: false,
      is_email_invoice: false,
      is_address_manually: false,
      isBillingAddress: true,
      billing_address: {address: '', city: '', state: '', zip_code: '', address2:''},
      service_address: {address: '', city: '', state: '', zip_code: '', address2:''},
      isAgreed: true,
      // is_btn_active: false,
      // is_basic_btn_active: false,
      errors: {},
      user_billing_info_uuid: '',
      card_number : '',
      card_expiry_month : '',
      card_expiry_year : '',
      card_cvv : '',
      // stax_customer_id : '',
      stax_public_apikey: '',
      // hideAddNewButton: false,
      cardList: [],
      // preferred_days: [],
      // preferred_technician_uuid: '',
      fieldTechnicianFilter: [],
      basicDetails: {},
      card_select: '',
      zipcodeCheck: null,
      is_coupon_valid: false,
      isApplyCouponCode:false,
      coupon_code_error_message:[],
      toggleServiceDaysFilter: false,
      is_save_clicked: false
    }
    this.basicDetail = null;
    this.sidebar = null;
  }

  componentDidMount = () => {
    this.props.getFieldTechnicianFilter();
    const stax_public_apikey = (!isEmpty(this.props.zipcodeCheck)) && (!isEmpty(this.props.zipcodeCheck.data)) && (!isEmpty(this.props.zipcodeCheck.data.results)) ? this.props.zipcodeCheck.data.results[0].stax_public_apikey : null;
    const field_office_uuid = (!isEmpty(this.props.zipcodeCheck)) && (!isEmpty(this.props.zipcodeCheck.data)) && (!isEmpty(this.props.zipcodeCheck.data.results)) ? this.props.zipcodeCheck.data.results[0].uuid : null;
    const field_office_zip = (!isEmpty(this.props.basicDetails)) && (!isEmpty(this.props.basicDetails.zipcode)) ? this.props.basicDetails.zipcode : null;

    this.setState({ stax_public_apikey: stax_public_apikey });
    this.props.getFieldOfficeById({
      zip_code : field_office_zip,
      franchises_uuid : field_office_uuid
    });
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (Object.keys(nextProps?.zipcodeCheck?.fieldOfficeDetail).length > 0
      && JSON.stringify(nextProps?.zipcodeCheck?.fieldOfficeDetail) !== JSON.stringify(this.state.franchises))
    {
      this.setState({
        loader: false,
        franchises: nextProps?.zipcodeCheck?.fieldOfficeDetail.data
      });
    }
   
    //get field technician filters
    if (nextProps?.FieldTechnicianFilter && nextProps?.FieldTechnicianFilter?.technicianList && nextProps?.FieldTechnicianFilter?.technicianList?.results && Object.keys(nextProps?.FieldTechnicianFilter?.technicianList?.results).length > 0) {
      this.setState({
        fieldTechnicianFilter: nextProps?.FieldTechnicianFilter?.technicianList?.results,
        loader:false
      });
    }

    if(nextProps && nextProps.basicDetails && nextProps.basicDetails.address){
      this.setState({
        service_address: nextProps.basicDetails.address,
        basicDetails:nextProps.basicDetails
      },() => {
        if(this.state.isBillingAddress){
          this.setState({billing_address:this.state.service_address, loader: false});
        }
      })
    }

    if (nextProps?.ValidateCouponCode && nextProps?.ValidateCouponCode?.validateCouponCode && nextProps?.ValidateCouponCode?.validateCouponCode?.is_coupon_valid && nextProps?.ValidateCouponCode?.validateCouponCode?.is_coupon_valid !== this.state.is_coupon_valid && this.state.coupon_code) {
      this.setState({ is_coupon_valid: nextProps?.ValidateCouponCode?.validateCouponCode?.is_coupon_valid,coupon_code_error_message:[]}, () => {
        // console.warn('is_coupon_valid', this.state.is_coupon_valid);
        this.onAddCoupon();
      });
    }

    if (Object.keys(nextProps?.ValidateCouponCode?.errors).length > 0 && nextProps?.ValidateCouponCode?.errors !== this.props?.ValidateCouponCode?.errors) {
      this.setState({
        is_coupon_valid: false,
        coupon_code_error_message:nextProps?.ValidateCouponCode?.errors.coupon_code
      }, () => {
        //console.warn('coupon_code_error_message', this.state.coupon_code_error_message);
      });
      
      errorHandle(nextProps?.ValidateCouponCode?.errors);
    }

    this.setState({loader: false});
  }

  // on billing info change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value })
  }

  // on preferred date changed
  onDataChange = (e) => {
    this.setState({
      preferred_start_date: e.target.checked ? e.target.value : null,
      display_preferred_start_date: null
    })
  }

  // on billing value change
  onBillingOptionsChanged = (e, item) => {
    const { cardList } = this.state;
    const idx = cardList?.findIndex(obj => obj.id === e);
    this.setState({
      cardList,
      card_select:cardList?.[idx]?.id,
      user_billing_info_uuid: cardList?.[idx]?.id,
      address: cardList?.[idx]?.address
    });
  };

  // on contact method changed
  onContactMethodChange = (e) => {
    const {contactMethods} = this.state;
    const idx = contactMethods?.indexOf(e.target.value);
    if (idx > -1) {
      contactMethods.splice(idx, 1);
    } else {
      contactMethods.push(e.target.value);
    }
    this.setState({contactMethods});
  };

  // Google Map Place API
  handleScriptLoad = () => {

    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  };
  removeEmpty=(obj) =>{
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
  }
  handlePlaceSelect = () => {
    const address= document?.getElementById('google_address')?.value;
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: this.removeEmpty({
        latlng: undefined,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const addressObject = res?.data?.results[0];
      let obj = {};
      map(addressObject?.address_components, (item) => {

        if (item?.types?.includes('administrative_area_level_2')) {
          obj = Object.assign(obj, { 'address': item.short_name })
        }
        if (item?.types?.includes('route')) {
          obj = Object.assign(obj, { 'route': item.long_name })
        }
        if (item?.types?.includes('street_number')) {
          obj = Object.assign(obj, { 'street_number': item.short_name })
        }
        if (item?.types?.includes('administrative_area_level_1')) {
          obj = Object.assign(obj, { 'state': item.short_name })
        }
        if (item?.types?.includes('locality')) {
          obj = Object.assign(obj, { 'city': item.long_name })
        }
        if (item?.types?.includes('postal_code')) {
          obj = Object.assign(obj, { 'zip_code': item.short_name })
        }
      });
      obj.address=`${obj?.street_number || ''} ${obj?.route || ''}`;
      this.setState({ address: obj }, () => {
        if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
          message.error('Please enter valid address')
        }
      });
    }).catch((err) => {
      console.log(err)
    })
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on address change
  onAddressChange = (e) => {
    const {billing_address} = this.state;
    Object.assign(billing_address, {[e.target.name]: e.target.value})
    this.setState({billing_address});
  };

  // card validation
  validate = () => {
    const {isAgreed, contactMethods, user_billing_info_uuid,payment_method,payment_method_card,card_select,isBillingAddress,billing_address} = this.state;
    this.setState({ is_save_clicked: true })
    const schema = yup.object().shape({
      isAgreed: yup.bool().oneOf([true], 'Field must be checked'),
      payment_method: yup.string().required('Please select a payment method.'),
      card_select: payment_method === "credit_card" ? yup.string().required('Please select a card.') : null,
      contactMethods: yup.array().required('Contact method is required'),
      isBillingAddress: yup.bool(),
      billing_address: yup.object().when("isBillingAddress", {is: false, then: yup.object().shape({
        address: yup.string().required("Address is required"),
        state: yup.string().required("State is required"),
        city: yup.string().required("City is required"),
        zip_code: yup.string().required("Zipcode is required").min(5, 'Your ZIP code is invalid.'),
        address2:yup.string()
      }) }),
    })

    const data = {
      isAgreed,
      contactMethods,
      payment_method,
      card_select,
      billing_address,
      isBillingAddress
    };

    schema.validate(data, { abortEarly: false }).then(() => {
      this.storeInLocal();
      this.setState({
        errors: {},
        loader: true
      }, () => {
        this.props.createServiceOrder();
      })
    }).catch((error) => {
      let err_data = {};
      map(error?.inner, (item) => {err_data[item.path] = item.message})
      this.setState({errors: err_data, loader: false})
    });
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3487></DP-3487>
   * card validation
   */
  cardValidation = () => {
    const { isBillingAddress, card_number, card_expiry_month, card_expiry_year, card_cvv } = this.state;
    const { basicDetails } = this.props;
    const { address } = basicDetails;
    const cardSchema = yup.object().shape({
      card_number : this.fattJs.validNumber ? null : yup.string().nullable().required('Card Number is required'),
      card_expiry_month : yup.string().nullable().required('Card expire month is required'),
      card_expiry_year : yup.string().nullable().required('Card expire year is required').min(4, 'Card expire year is invalid.').max(4, 'Card expire year is invalid.'),
      card_cvv : this.fattJs.validCvv ? null : yup.string().nullable().required('Card CVC is required'),
      isBillingAddress: yup.bool(),
      address: yup.object().when("isBillingAddress", {is: false, then: yup.object().shape({
        address: yup.string().required("Address is required"),
        state: yup.string().required("State is required"),
        city: yup.string().required("City is required"),
        zip_code: yup.string().required("Zipcode is required").min(5, 'Your ZIP code is invalid.')
      }) }),
    })
    const cardData = { isBillingAddress, address, card_number, card_expiry_month, card_expiry_year, card_cvv };
    cardSchema.validate(cardData, { abortEarly: false }).then(() => {
      this.storeInLocal()
      this.setState({errors: {}, loader: true}, () => {
        this.addNewCard()
      })
    }).catch((error) => {
      let err_data = {};
      map(error?.inner, (item) => {err_data[item.path] = item.message})
      this.setState({errors: err_data});
      message.error(`Valid ${err_data.card_number}. Valid ${err_data.card_cvv}`);
    });
  }
  
  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3487></DP-3487>
   * Add New Card
   */
  addNewCard = () => {
    const {
      card_number,
      card_expiry_month,
      card_expiry_year 
    } = this.state;
    let { cardList } = this.state;
    const { basicDetails } = this.props;
    const { address } = basicDetails;

    if (!address?.geo_location) {
      delete address?.geo_location;
    }

    this.setState({ loader: true });

    const token_obj = {
      address_1: address ? address.address : null,
      address_city: address ? address.city : null,
      address_state: address ? address.state : null,
      address_zip: address ? address.zip_code : null,
      month : card_expiry_month ? card_expiry_month : null,
      year : card_expiry_year ? card_expiry_year : null,
      card_number: card_number ? card_number : null,
      email: basicDetails?.emails ? basicDetails?.emails[0]?.email : null,
      firstname: basicDetails && basicDetails.firstName ? basicDetails.firstName : null,
      lastname: basicDetails && basicDetails.lastName ? basicDetails.lastName : null,
      method: 'card',
      person_name: basicDetails ? `${basicDetails.firstName} ${basicDetails.lastName}` : null,
      phone: basicDetails?.phone_numbers ? basicDetails?.phone_numbers[0]?.phone : null
    }
    
    this.fattJs.tokenize(token_obj).then((res) => {
      
      if (res && Object.keys(res).length > 0) {
        cardList.push(res);

        this.setState({
          isAddNewCard: false,
          cardList: cardList, 
          loader : false
        });
      }
    }).catch((err) => {
      this.setState({ loader : false });

      map(err.fieldErrors, (item) => {
        message.error(item.message,10);
      });
      message.error(err.message,10);
    });
  }

  // store data in local
  storeInLocal = () => {
    const {
      isBillingAddress,
      service_address,
      billing_address,
      preferred_start_date,
      contactMethods,
      isAgreed,
      charge_invoice_card,
      is_print_and_mail_invoices,
      is_email_invoice,
      user_billing_info_uuid,
      stax_public_apikey,payment_method,card_select,payment_method_card,cardList
    } = this.state;
    this.props.setBillingInfoData({
      isBillingAddress,
      service_address,
      billing_address,
      preferred_start_date,
      contactMethods,
      isAgreed,payment_method,card_select,payment_method_card,
      charge_invoice_card,
      is_print_and_mail_invoices,
      is_email_invoice,
      user_billing_info_uuid,
      stax_public_apikey,cardList
    });
  }

  onCancel = () => {
    this.props.history.goBack();
    sessionStorage.removeItem('step1');
    sessionStorage.removeItem('step2');
    sessionStorage.removeItem('calcData');
    sessionStorage.removeItem('pricingCalc');
    sessionStorage.removeItem('basicDetail');
  }

  // render all state
  renderAllState = () => {
    return AllState.AllState.map((item, i) => {
      return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
    });
  }

  // render extra footer
  renderExtraFooter = () => {
    return (
      <div className="data_indicator">
        <a href="/#" onClick={(e) => { e.preventDefault(); }} className="btn">Available</a>
        <a href="/#" onClick={(e) => { e.preventDefault(); }} className="btn unavailable">Unavailable</a>
      </div>
    )
  }

  // render existing card
  renderCardList = () => {
    const { cardList, user_billing_info_uuid } = this.state;
    return (
      <div className="card order2">
        <div className="card-title flex">
          <h5>Existing Cards</h5>
          <div>
            <button
              className="btn btn-warning"
              onClick={() => this.loadStax() }
            >Add New</button>
          </div>
        </div>
        <div className="card-body mt-10">
          {cardList?.length > 0 ?
            map(orderBy(cardList, 'id', 'asc'), (item, index) => {
              const exp_date = `${item.card_exp.toString().slice(0,2)}/${item.card_exp.toString().slice(2,6)}`;
              return (
                <React.Fragment key={`card${index}`}>
                  <div className="flex ai-center mb-10" key={`card${item?.id}`}>
                    <input
                      type="checkbox"
                      className="fitem-ck-input"
                      id={`${item?.id}`}
                      name={`user_billing_info_uuid`}
                      checked={item?.id === user_billing_info_uuid}
                      onChange={(e) => this.onBillingOptionsChanged(e, item)}
                    />
                    <div className="card_img flex ai-center flex-1 ml-10">
                      {item.card_type === 'visa' ?
                        <img height="25" src={visa} alt="" /> :
                        <img height="25" src={american} alt="" />} &nbsp;&nbsp;
                      <div className={'flex-1'}>
                        <div>
                          <label className="m-0">{item.card_type} ending in {item.card_last_four}</label>
                        </div>
                        <div>
                          <label className="m-0">Exp : {exp_date}</label>
                        </div>
                      </div>
                      <Popconfirm
                        title="Are you sure?"
                        onConfirm={() => {
                          this.setState({loader: true})
                          this.props.deleteCard({uuid: item?.id})
                          setTimeout(() => this.props.getCardList({user__uuid: this.props?.customerId}), 1000)
                        }}
                        okText="Yes"
                        cancelText="No"
                        overlayClassName={"popup-width"}
                      >
                        <DeleteOutlined/>
                      </Popconfirm>
                    </div>
                  </div>
                </React.Fragment>
              )
            })
            : <EmptyData />
          }
        </div>
      </div>
    )
  }
  
  // render add card modal
  renderAddCardModal = () => {
    const { isAddNewCard, errors } = this.state;
    return (
      <Modal
        title="Add New Card"
        visible={isAddNewCard}
        onCancel={() => { this.setState({isAddNewCard: false}) }}
        footer={[
          <button
            key="cancel"
            className="btn btn-brand btn-bdr"
            onClick={() => {this.setState({isAddNewCard: false})
            }}>Cancel</button>,
          <button
            key="submit"
            className={`btn btn-warning`}
            onClick={() => this.cardValidation()}
          >Add</button>
        ]}
      >
        <div>
          <div className={"flex mt-10"}>
            <div className={"flex-1"}>
              <div className="form-group">

                <div className="fitem">
                  <label>Card Number</label>
                  <div id="card-number" className="form--control"></div>
                </div>

                <div className="fitem">
                  <label>CVV</label>
                  <div id="card-cvv" className="form--control"></div>
                </div>

                <div className="half-fitem fitem">
                  <div className="half-fitem fitem">
                    <label>Expiration Month</label>
                    <input type="text" className="form--control" placeholder="MM" maxLength={2} 
                      inputMode="numeric"
                      onPaste={(event) => {
                        if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                          event.preventDefault();
                        }
                      }}
                      onKeyPress={(e) => {
                        const pattern = /[0-9]/;
                        const inputChar = String.fromCharCode(e.charCode);
                        if (!pattern.test(inputChar)
                        ) {
                          // invalid character, prevent input
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => { this.setState({ card_expiry_month: e.target.value }) }} 
                    />
                    {errors?.['card_expiry_month'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_month']}</label> : ''}
                  </div>
                  <div className="half-fitem fitem">
                    <label>Expiration Year</label>
                    <input type="text" className="form--control" placeholder="YYYY" maxLength={4} 
                      inputMode="numeric"
                      onPaste={(event) => {
                        if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                          event.preventDefault();
                        }
                      }}
                      onKeyPress={(e) => {
                        const pattern = /[0-9]/;
                        const inputChar = String.fromCharCode(e.charCode);
                        if (!pattern.test(inputChar)
                        ) {
                          // invalid character, prevent input
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => { this.setState({ card_expiry_year: e.target.value }) }} 
                    />
                    {errors?.['card_expiry_year'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_year']}</label> : ''}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
  
  loadStax = () => {
    this.setState({ is_edit_info: true, can_edit: false, isAddNewCard: true });    
    const { stax_public_apikey } = this.state;
    if (stax_public_apikey) {
      const FattJs = window.FattJs;
      const fattJs = new FattJs(stax_public_apikey, {
        number: {
          id: "card-number",
          placeholder: "Card Number",
          style: "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-number div
        },
        cvv: {
          id: "card-cvv",
          placeholder: "CVV",
          style: "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-cvv div
        }
      });
      fattJs.showCardForm().then(handler => {
        console.log('form loaded', handler);
      }).catch(err => {
        console.error('error occur', err);
      });
      this.fattJs = fattJs;
    } else {
      message.error('Error occur while loading stax. please contact to admin.', 10);
    }
  }

  onEnter = (event) => {
    if (event.key === "Enter") {
      this.onAddCoupon();
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3294></DP-3294>
   */
  onAddCoupon = () => {
    const {coupon_code, prepay_months, isPrePay} = this.state;
    this.props.setCouponCode && this.props.setCouponCode(coupon_code)
    sessionStorage.setItem('calcData', JSON.stringify({coupon_code, prepay_months, isPrePay}))
    this.props.priceCalc({coupon_code, prepay_months, isPrePay});
  }

  // on billing info change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value })
  }

  setBasicDetails = (data) => {
    this.setState({ basicDetails: data }, () => {
      // console.warn('basicDetails', data);
    });
  }
  
  validateCoupon = () => {
    // console.warn('validateCoupon calling', this.props)
    const { coupon_code } = this.state;
    this.setState({isApplyCouponCode:true});
    // console.warn('coupon_code', coupon_code)
    const cardSchema = yup.object().shape({
      coupon_code: yup.string().required("Enter a coupon code.")
    })
    const cardData = { coupon_code };
    cardSchema.validate(cardData, { abortEarly: false }).then(() => {
      this.setState({errors: {}});
      this.props.validateCoupon({
        coupon_code: coupon_code,
        email: this.state.basicDetails.emails[0].email
      });
    }).catch((error) => {
      let err_data = {};
      map(error?.inner, (item) => {err_data[item.path] = item.message})
      this.setState({errors: err_data});
    });
  }

  onClearCoupon = () => {
    this.setState({ coupon_code: '', is_coupon_valid: false, coupon_code_error_message:[],isApplyCouponCode:false }, () => {
      const {coupon_code, prepay_months, isPrePay} = this.state;
      sessionStorage.setItem('calcData', JSON.stringify({coupon_code, prepay_months, isPrePay}))
      // if (pricingCalc) sessionStorage.setItem('PricingCalc', JSON.stringify(pricingCalc))
      this.props.priceCalc({coupon_code, prepay_months, isPrePay})
    });

    console.log(this.state,'state');

  }

  closeTechnicianFilter = () => {
    this.setState({ toggleServiceDaysFilter: false })
  }

  toggleServiceDays = () => {
    const { toggleServiceDaysFilter } = this.state;
    if (toggleServiceDaysFilter) {
      this.setState({ toggleServiceDaysFilter: false })
    } else {
      this.setState({ toggleServiceDaysFilter: true, toggleServiceOrderFilter: false,     toggleWorkOrderFilter: false, toggleStatusFilter: false })
    }
  }

  // clearTechnician = () => {
  //   this.setState({ preferred_days: [], toggleServiceDaysFilter: false });
  // }

  onServiceDaysChanged = (e, index) => {
    const { preferred_days, allServiceDaysSelected } = this.state;
    let arrServiceDays = [...preferred_days];
    if (e.target.checked) {
      if (index === null) {
        arrServiceDays = [];
        preferred_service_days.forEach(element => {
          element['is_change'] = !allServiceDaysSelected;
          if(!allServiceDaysSelected) {
            arrServiceDays.push(element?.value);
          }
        });
      } else {
        if (arrServiceDays.indexOf(e.target.id) === -1) {
          arrServiceDays.push(e.target.id)
          preferred_service_days[index]['is_change'] = true;
        }
      }
    } else {
      if (index === null) {
        arrServiceDays = [];
        preferred_service_days.forEach(element => {
          element['is_change'] = false
        });
      } else {
        const ind = arrServiceDays.indexOf(e.target.id);
        if (ind > -1) {
          arrServiceDays.splice(ind, 1);
          preferred_service_days[index]['is_change'] = false;
        }
      }
    }
    this.setState({ preferred_days: arrServiceDays, allServiceDaysSelected: index === null ? !allServiceDaysSelected : false },() => {
      // console.warn('technician__uuid', this.state.technician__uuid);
    });    
  }

  getSelectedArray = () => {
    const toString = this.state.preferred_days && this.state.preferred_days.length ? this.state.preferred_days.toString().split(',').join(', ') : null;
    return toString;
  }

  /*
  renderServiceDaysFilters =  () => {
    const { toggleServiceDaysFilter, preferred_days } = this.state;
    return (
      <TechnicianOutsideAlerter
        closeTechnicianFilter={this.closeTechnicianFilter}
      >
        <div className="form-group image-input custom-preferred-days-dropdown ">
          <div className="fitem">
            <div className="cpreferred-input">
              <input type="text" id="txtTechnician" placeholder=""  onFocus={() => {this.toggleServiceDays() }} />
              <label className="lbl-list"  htmlFor=""> {preferred_days && preferred_days.length === 0 ? 'Any' : this.getSelectedArray()}
              </label>

            </div>  
            {preferred_days && preferred_days.length === 0 && 
            <img src={chevronDown} alt="" onClick={() => { this.toggleServiceDays() }} />
            }
          </div>
          {toggleServiceDaysFilter && <div className="field-dropdown custom-preferred-days">
            <div className="field-dropdown-body">
              {map(preferred_service_days, (item, index) => {
                return (
                  <div key={index} className="fitem-check">
                    <input id={item?.value} type="checkbox" className="fitem-ck-input" onChange={(e) => { this.onServiceDaysChanged(e, index)}} checked={item.is_change} />
                    <label htmlFor={item?.value} className="fitem-ck-txt">{item?.key}</label>
                  </div>
                )
              })}
            </div>
          </div>}
        </div>
      </TechnicianOutsideAlerter>
    )
  }
  */

  render() {
    const {
      coupon_code,
      isApplyCouponCode,
      is_coupon_valid,
      cardList,card_select,
      charge_invoice_card,
      payment_method,
      isBillingAddress,
      service_address,
      billing_address,
      franchises,
      preferred_start_date,
      contactMethods,
      display_preferred_start_date,
      isAgreed,
      errors,
      loader,
      fieldTechnicianFilter,
      basicDetails,
      is_print_and_mail_invoices,
      is_email_invoice,
      coupon_code_error_message
    } = this.state;
    const {serviceInfo} = this.props;

    return (
      <div className="container">
        {loader && <Loader />}
        <div className="fluid-block">
          <div className="article-block">
            <BasicDetail
              ref={(ref) => this.basicDetail = ref}

              // Reducers
              zipcodeCheck={this.props.zipcodeCheck}
              GoogleApi={this.props.GoogleApi}
              EmailVerifycation={this.props.EmailVerifycation}

              // Apis
              basicDetails={basicDetails}
              checkEmail={this.props.checkEmail}
              checkZipCode={this.props.checkZipCode}
              setBasicDetails={this.setBasicDetails}
              resetCheckZipcode={this.props.resetCheckZipcode}
              getGeocodeAddress={this.props.getGeocodeAddress}
              resetGeocodeAddress={this.props.resetGeocodeAddress}
            />

            <div className="adetail">
              <h3 style={{marginTop: "10px"}}>Work Order Information</h3>
              <div className="form-block billing-payfull-wrap">
                {/* Preferred Start Date Block */}
                <div className="frow">
                  <label>Preferred Start Date</label>
                  <div className="oplist">
                    {/*render date list*/}
                    {map(franchises?.sort()?.slice(0, 3), (item, i) => {
                      return (
                        <div className="inline-checks flex-1" key={`preferred_start_dates${i}`}>
                          <label htmlFor={item?.value} className={preferred_start_date === item ? 'active' : ''}>
                            <input
                              type="radio"
                              id={item?.value}
                              name="preferred_start_date"
                              checked={preferred_start_date === item}
                              value={item}
                              className=""
                              onChange={(e) => { this.onDataChange(e) }}
                            />
                            <span>{moment(item, "MM-DD-YYYY").format('ddd, MMM DD')}</span>
                          </label>
                        </div>
                      )})}
                    <div className="inline-checks flex-1">
                      <DatePicker
                        renderExtraFooter={() => this.renderExtraFooter()}
                        inputReadOnly
                        mode={'date'}
                        className={display_preferred_start_date ? 'active' : 'box_opacity'}
                        // disabled={!zipcodeCheck}
                        placeholder={'Select another date'}
                        format={"ddd, MMM DD"}
                        value={display_preferred_start_date}
                        onChange={(e) => {
                          this.setState({
                            display_preferred_start_date: e,
                            preferred_start_date: moment(e).format('MM-DD-YYYY')
                          });
                        }}
                        disabledDate={current => {
                          return !franchises?.sort()?.slice(3, franchises.length).includes(moment(current).format('MM-DD-YYYY'))
                        }}
                          
                      />
                    </div>
                    {errors?.['preferred_start_date'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['preferred_start_date']}</label> : ''}
                  </div>
                </div>

                {/* Contact Method Block */}
                <div className="frow pt-10">
                  <label>Contact Method <sup>*</sup></label>
                  <div className="oplist">
                    {map(contact_methods, (item, index) => {
                      const isInclude = contactMethods?.includes(item?.value);
                      return (
                        <div className="inline-checks flex-1" key={`contactMethod${index}`}>
                          <label htmlFor={item?.value} className={isInclude ? 'active' : ''}>
                            <input type="checkbox" id={item?.value} name='contactMethod'
                              //  disabled={!zipcodeCheck}
                              className="" value={item?.value} onChange={(e) => this.onContactMethodChange(e)}/>
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )
                    })}
                  </div>
                  {errors?.['contactMethods'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['contactMethods']}</label> : ''}
                </div>
              
                {/* Invoice Preferences Block */}
                <div className="frow pt-10">
                  <label>Invoice Preferences</label>
                  <div className="oplist">
                    {map(invoice_preferences, (item, index) => {
                      return (
                        <div className="inline-checks flex-1" key={`contactMethod${index}`}>
                          <label
                            htmlFor={item?.value}
                            className={(item?.value === 'is_print_and_mail_invoices' && is_print_and_mail_invoices) ? 'active' : (item?.value === 'is_email_invoice' && is_email_invoice) ? 'active' : ''  }
                          >
                            <input 
                              type="checkbox" 
                              id={item?.value} 
                              name={item?.value} 
                              value={item?.value}
                              onChange={(e) => {
                                if (e.target.value === 'is_print_and_mail_invoices') {
                                  this.setState({ is_print_and_mail_invoices: e?.target?.checked }, () => {
                                    console.warn('is_print_and_mail_invoices', this.state.is_print_and_mail_invoices)
                                  });
                                }
                                if (e.target.value === 'is_email_invoice') {
                                  this.setState({ is_email_invoice: e?.target?.checked }, () => {
                                    console.warn('is_email_invoice', this.state.is_email_invoice)
                                  });
                                }
                              }}
                            />
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )
                    })}
                  </div>
                </div>

                {/* Preferred Service Days Block */}
                {/* <div className="frow md-label">
                  <div className="pi-block">
                    <div className="field-group">
                      <label>Preferred Service Days <sup>*</sup></label>
                      {this.renderServiceDaysFilters()}
                    </div>
                  </div>
                  {errors?.['preferred_days'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['preferred_days']}</label> : ''}
                </div> */}

                {/* Preferred Technician Block */}
                {/* <div className="frow md-label">
                  <div className="pi-block">
                    <div className="field-group">
                      <label>Preferred Technician <sup>*</sup></label>
                      <Select 
                        showSearch
                        optionFilterProp="children"
                        placeholder="Any"
                        value={preferred_technician_uuid || undefined}
                        onChange={(e) => {
                          this.setState({preferred_technician_uuid:e})
                        }}
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {map(fieldTechnicianFilter, (item, index) => {
                          return (
                            <Option key={index} value={item.uuid}>{item?.user?.first_name}, {item?.user?.last_name}</Option>
                          )
                        })}
                      </Select>
                    </div>
                  </div>
                  {errors?.['preferred_technician_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['preferred_technician_uuid']}</label> : ''}
                </div> */}
                <hr />

                {/* Billing Address Block */}
                <div className="frow pt-10">
                  <h3>Billing Address</h3>
                  <div className="max-w-328">
                    <div className="fitem-check mt-10 mb-10">
                      <input 
                        type="checkbox" 
                        className="fitem-ck-input" 
                        id="isBillingAddress" 
                        name="isBillingAddress"
                        checked={isBillingAddress} 
                        value={isBillingAddress} 
                        onChange={(e) => {
                          this.setState({isBillingAddress: e.target.checked}, () => {
                            if (this.state.isBillingAddress) {
                              this.setState({billing_address: service_address,isBillingAddress:true})
                            } else {
                              this.setState({billing_address: {address: '', state: '', city: '', zip_code: ''},isBillingAddress:false})
                            }
                          })
                        }}
                      />
                      <label htmlFor="isBillingAddress" className="fitem-ck-txt">Same as Service Address</label>
                    </div>
                    <div className="form-group mb-20">
                      <div className="fitem">
                        <input
                          type="text"
                          placeholder="Address"
                          name="address"
                          value={billing_address?.address}
                          onChange={(e) => this.onAddressChange(e)}
                        />
                        {errors?.['billing_address.address'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['billing_address.address']}</label> : ''}
                      </div>
                      <div className="fitem">
                        <input
                          type="text"
                          placeholder="Address Line 2 (Optional)"
                          name="address2"
                          value={billing_address?.address2 || ''}
                          onChange={(e) => this.onAddressChange(e)}
                        />
                      </div>
                      <div className="half-fitem fitem">
                        <div className="half-fitem fitem">
                          <input
                            type="text"
                            placeholder="City"
                            name="city"
                            value={billing_address?.city}
                            onChange={(e) => this.onAddressChange(e)}
                          />
                          {errors?.['billing_address.city'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['billing_address.city']}</label> : ''}
                        </div>
                        <div className="half-fitem fitem">
                          <Select
                            showArrow={true}
                            name="state"
                            placeholder="State"
                            onChange={(value) => this.onAddressChange({target: {name: 'state', value: value}})}
                            value={billing_address?.state || undefined}
                            virtual={false}
                          >
                            {this.renderAllState()}
                          </Select>
                          {errors?.['billing_address.state'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['billing_address.state']}</label> : ''}
                        </div>
                        <div className="half-fitem fitem">
                          <input
                            type="text"
                            className='form--control'
                            placeholder="ZIP Code"
                            name="zip_code"
                            maxLength={5}
                            minLength={5}
                            onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChange(e)}
                            value={billing_address?.zip_code || ''}
                          />
                          {errors?.['billing_address.zip_code'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['billing_address.zip_code']}</label> : ''}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr/>
                {/* Payment Information Block */}
                <div className="frow pt-10">
                  <h3>Payment Information</h3>

                  <div className="pi-block max-w-328">
                  
                    {/* Pre-Payment Block */}
                    {/* <div className="field-group">
                      <label>Pre-Payment <sup>*</sup></label>
                      <Select
                        placeholder={"Select Prepay"}
                        value={pre_payment || undefined}
                        onChange={(e) => {
                          this.setState({pre_payment : e});
                        }}
                      >
                        {map(pre_payment_methods, (item, index) => {
                          return (
                            <Option key={index} value={item.value}>
                              <React.Fragment>
                                <span>{item.key}</span><br />
                                <span>{item.text}</span>
                              </React.Fragment>
                            </Option>
                          )
                        })}
                      </Select>
                      {errors?.['pre_payment'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['pre_payment']}</label> : ''}

                    </div> */}

                    {/* Add Coupon Block */}
                    <div className="field-group">
                      <label>Add Coupon</label>
                      <div className="flex">
                        <input 
                          type="text" 
                          className="flex-1" 
                          name="coupon_code"
                          placeholder={"Add Coupon"} 
                          value={coupon_code || ''} 
                          onChange={(e) => this.setState({ [e.target.name]: e.target.value, isApplyCouponCode:false, })}
                          onKeyUp={this.onEnter.bind(this)}
                        />
                        {/* disabled */}
                        {!is_coupon_valid &&  
                        <button type="button" className="coupne-btn btn p-10 ml-10" onClick={(e) => {this.validateCoupon()} }>Apply</button>
                        }
                        {is_coupon_valid && 
                        <button type="button" className="coupne-btn btn p-10 ml-10" onClick={(e) => {this.onClearCoupon()} }>Clear</button>
                        }
                      </div>
                      {!is_coupon_valid && coupon_code &&  isApplyCouponCode && coupon_code_error_message && coupon_code_error_message.length > 0 &&   <label className="has_err_msg"><i className="las la-times" /> Invalid coupon code</label>}
                      {is_coupon_valid && coupon_code && isApplyCouponCode && <label className="has_success_msg"><i className="las la-check"></i> Coupon applied</label>}

                      {errors?.['coupon_code'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['coupon_code']}</label> : ''}
                    </div>
                   
                    {/* Payment Method Block */}
                    <div className="field-group">
                      <label>Payment Method <sup>*</sup></label>
                      <div className="mb-10">
                        <Select
                          placeholder="Select"
                          value={payment_method || undefined}
                          onChange={(e) => { 
                            this.setState({payment_method: e});
                          }}
                        >
                          {map(payment_methods, (item, index) => {
                            return (
                              <Option key={index} value={item.value}>{item.key}</Option>
                            )
                          })}
                        </Select>
                        {errors?.['payment_method'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['payment_method']}</label> : ''}
                        {/* {errors?.['payment_method_card'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['payment_method_card']}</label> : ''} */}
                      </div>
                      {payment_method === "credit_card" ? <div>
                        <Select
                          placeholder={"Select"}
                          disabled={cardList.length === 0}
                          value={card_select || undefined}
                          onChange={(e) => this.onBillingOptionsChanged(e)}
                        >
                          {map(cardList, (item, index) => {
                            return (
                              <Option key={index} value={item?.id}>
                                <React.Fragment>
                                  <div className="card_img flex ai-center flex-1 ml-10">
                                    {item.card_type === 'visa' ?
                                      <img height="25" src={visa} alt="" /> :
                                      <img height="25" src={american} alt="" />
                                    } &nbsp;&nbsp;
                                    <div className={'flex-1'}>
                                      <div>
                                        <label className="m-0">{!isEmpty(item.card_type) ? `${item.card_type} ending in ${item.card_last_four}` : ''}</label>
                                      </div>
                                    </div>
                                  </div>
                                </React.Fragment>
                              </Option>
                            )
                          })}
                        </Select>
                        {errors?.['card_select'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['card_select']}</label> : ''}
                      </div> : ''}
                    </div>
                  
                    {payment_method === "credit_card" ? <div className="fitem-check mt-10">
                      <input 
                        type="checkbox" 
                        className="fitem-ck-input" 
                        id="charge" 
                        name="charge_invoice_card" 
                        value={charge_invoice_card}
                        onChange={(e) => this.onTextChange(e, 'bool')}
                      />
                      <label htmlFor="charge" className="fitem-ck-txt">Charge invoices to card</label>
                    </div> : ''}
                    { payment_method === "credit_card" ? <a className="flex ai-center justify-content-start mt-10" onClick={() => this.loadStax() }><img className="icoimg ml-0 mr-5" src={plus_icon_green} alt="" /> <strong>Add Card</strong></a> : '' }
                  </div>
                </div>
                <hr style={{margin:'20px 0'}}/>
                {/* <div className="frow md-label">
                <h4>Payment Information</h4>
                <span>Accounts are charged the beginning of each month for service provided the prior month.</span>
                {this.renderCardList()}
                {errors?.['user_billing_info_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['user_billing_info_uuid']}</label> : ''}
              </div>
              <hr/> */}
                <div className="frow">
                  <h4> Terms of Service</h4>
                  {/*TODO: Add or delete Terms of Service link */}
                  <span>By signing up, I grant my permission for DoodyCalls to access my property and agree to the full DoodyCalls 
                    <a>Terms of Service</a> and 
                    <a href="https://www.doodycalls.com/privacy-policy/">Privacy Policy.</a></span>
                  <div className="fitem-check mt-10">
                    <input
                      id="isAgreed"
                      name="isAgreed"
                      checked={isAgreed}
                      onChange={(e) => this.onTextChange(e, 'bool')}
                      type="checkbox" className="fitem-ck-input"
                      //  disabled={!zipcodeCheck}
                    />
                    <label htmlFor="isAgreed" className="fitem-ck-txt">Customer verbally agreed</label>
                  </div>
                  {errors?.['isAgreed'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['isAgreed']}</label> : ''}
                </div>
              </div>
            </div>
          </div>
          <SideBar
            ref={(ref) => this.sidebar = ref}
            coupon_code={this.state.coupon_code}
            // reducers
            PricingCalc={this.props.PricingCalc}
            //
            priceCalc={this.props.priceCalc}
            currentTab={this.props.currentTab}
            serviceInfo={serviceInfo}
          />
        </div>
        <div className="fix-btn-grp">
          <button className="btn btn-white" onClick={() => this.onCancel()}>Exit Creator</button>
          <button className={`btn btn-warning`} onClick={() => this.validate()}>Add New Customer</button>
        </div>
        {this.renderAddCardModal()}
      </div>
    )
  }
}

export default BillingInfo;